import type {UserIdentity} from '~shared/models/wiki';

import {createThunk} from '~ui/store/utils';

export const getMyUserInfo = createThunk('user/get-info', (_: void, thunkAPI) => {
    return thunkAPI.extra.sdk.wiki.getMyUserInfo();
});

export const getResolvedUserInfo = createThunk(
    'user/get-resolver-info',
    (identity: UserIdentity, thunkAPI) => {
        return thunkAPI.extra.sdk.wiki.resolveUsersIdentities({
            identities: [identity],
        });
    },
);
